module.exports = __webpack_public_path__ + "static/media/meaningful-review-product3-full.3f5ca11d.svg";